
import React, { useEffect,useState,useRef } from 'react';
import {Modal,Button } from 'antd'
// import {api_candidates_list} from '../../../api';
// import { ProTable } from '@ant-design/pro-components';
// import { UnorderedListOutlined } from '@ant-design/icons';
import Candidate from '../../components/candidate';

const screenHeight = document.body.clientHeight;
// const screenWidth = document.body.clientWidth;

const App = (props) => {
    const {showModal, rowInfo, closeModal, invitationStatusEnum, candidatesStatusEnum} = props;

    useEffect(() => {
        // if(showModal && rowInfo.work_order_id)
        //   actionRef.current?.reload();
            // setTableData(JSON.parse(rowInfo.client_list));
        // else
        //     setTableData([]);
      }, []);
  
    return (
      <div>
        <Modal 
            key="scoredetail"
            title={'工单 '+rowInfo.work_order_id+' 候选人列表'}
            open={showModal}
            width={"70%"}
            bodyStyle={{height:screenHeight*0.5,overflowY:"scroll"}}
            centered
            maskClosable={false}
            footer={[<Button  className="m-btn-white" onClick={closeModal}>
            关闭
            </Button>,] }
            onCancel={closeModal}>


          <Candidate
            from="order"
            showModal={showModal}
            rowInfo={rowInfo}
            invitationStatusEnum={invitationStatusEnum}
            candidatesStatusEnum={candidatesStatusEnum}
            />

        </Modal>

      </div>

    )
}

export default App